'use client';

import { useSyncExternalStore } from 'react';
import { NetworkStatus } from './types';
function subscribe(callback: () => void) {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}
function getSnapshot(): NetworkStatus {
  return typeof window !== 'undefined' && window.navigator.onLine ? 'online' : 'offline';
}
function useNetworkStatus() {
  return useSyncExternalStore(subscribe, getSnapshot, _temp);
}
function _temp() {
  return "online";
}
export default useNetworkStatus;